export const facebookIcon = "fa-brands fa-facebook-f"
export const instagramIcon = "fa-brands fa-instagram"
export const telegramIcon = "fa-brands fa-telegram"
export const twitterIcon = "fa-brands fa-x-twitter"
export const downloadIcon = "fa-solid fa-arrow-up-right-from-square"
export const androidIcon = "fa-brands fa-android"
export const iosIcon = "fa-brands fa-app-store-ios"
export const webIcon = "fa-solid fa-globe"
export const playIcon = "fa-regular fa-circle-play"